<template>
  <element>
    <AppBar :title="title" />
    <v-container class="pt-0 pl-0 pr-0">
      <v-row no-gutters class="d-flex justify-content-center">
        <v-icon class="page-icon pt-1 mr-2" color="#2e384d" size="60"
          >mdi-camera</v-icon
        >
        <v-icon class="page-icon pb-1 ml-2" color="#2e384d" size="64"
          >mdi-car-door</v-icon
        >
      </v-row>
      <CameraDesktop
        ref="cameraDesktop"
        :documentType="documentType"
        :dataId="partId"
      />
      <v-progress-circular
        v-if="isUploading"
        class="mt-2"
        indeterminate
        color="#033e8c"
      ></v-progress-circular>
      <v-row no-gutters class="px-3 mt-4">
        <v-btn
          class="submit-btn"
          height="45px"
          color="#033e8c"
          depressed
          block
          dark
          @click="complete(true)"
        >
          {{ $t("takePartPhotosCarReg.enterAnotherPartBtnTitle") }}
        </v-btn>
        <v-btn
          class="submit-btn"
          height="45px"
          color="#57D701"
          depressed
          block
          dark
          @click="complete(false)"
        >
          {{ $t("takePartPhotosCarReg.finishtBtnTitle") }}
        </v-btn>
      </v-row>
    </v-container>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue";
import CameraDesktop from "@/components/camera/CameraDesktop.vue";
import { DOCUMENT_TYPE_PART_PICTURE } from "@/constants";

export default {
  name: "TakePartPhotosCarRegPage",
  props: {},
  components: {
    AppBar,
    CameraDesktop,
  },
  data() {
    return {
      title: "",
      valid: false,
      partId: -1,
      documentType: DOCUMENT_TYPE_PART_PICTURE,
      isUploading: false,
    };
  },
  methods: {
    async uploadPictures() {
      await this.$refs.cameraDesktop.upload();
    },
    
    complete(enter_new_part) {
      this.isUploading = true;

      this.uploadPictures();

      const taskId = this.$store.getters.getCurrentTask?.id;
      const variables = {
      "variables": {
        "enter_new_part": { 
          "value": enter_new_part,
          "type":"Boolean"
        }
       }
      }
      
      if (taskId) {
        this.$store
          .dispatch("completeTask", {
            taskId,
            variables
          })
          .then(() => {
            console.log('completeTask ok');
            //this.$router.push({ name: "dashboard" });
          })
          .catch((error) => {
            console.log("Failed completing task!", taskId, error);
          })
          .finally(() => {
            this.isUploading = false;
          });
      } else {
        this.isUploading = false;
      }
    },
  },
  created() {
    this.title = this.$store.getters.getCurrentTask.taskName;
    const pid = this.$store.getters.getCurrentPID;
    this.$store
      .dispatch("retrieveProcessVariables", pid)
      .then((response) => {
        try {
          this.partId = parseInt(response.data.data.part_id.value);
          console.log("------------partId: ", this.partId);
        } catch (error) {
          console.log("Failed retrieving variables from API.", error);
        }
      })
      .catch((error) => {
        console.log("Failed retrieving variables from API", error);
      });
  },
};
</script>

<style scoped>
</style>
